import {
  OTSPRequest,
  OTSPResponse,
  PolicyRequest,
  SchedulePayment,
} from '@aaa-ncnu-ie/mypolicy-api-billing';
import {
  CustomerPolicy,
  PolicySummary,
  PolicyTypeCd,
} from '@aaa-ncnu-ie/mypolicy-api-customers';
import { useQuery } from '@tanstack/react-query';

import axios from './axios';

type FormattedOTSPResponse = Record<string, SchedulePayment>;

export const getOTSPDetails = async (
  policies?: PolicySummary[] | CustomerPolicy[]
): Promise<FormattedOTSPResponse> => {
  if (!policies || policies.length < 1) {
    return Promise.reject(new Error('missing arguments'));
  }

  const formattedPoliciesList: PolicyRequest[] = policies.map((policy) => ({
    policyNumber: policy.policyNumber,
    productType: policy.policyTypeCd as PolicyTypeCd,
    dataSource: policy.dataSource,
  }));

  const requestBody: OTSPRequest = {
    policies: formattedPoliciesList,
  };
  const { data } = await axios.post<OTSPResponse>(
    `${
      import.meta.env.VITE_MYPOLICY_BILLING_API_URL
    }/v1/payment/schedule/retrieveByPolicyInfo`,
    requestBody,
    {
      headers: {
        'Content-Type': 'application/json',
        accept: 'application/json',
      },
    }
  );

  // Change the response format from an array to an object so we can perform
  // constant time OTSP checks by policyNumber and remove any OTSP responses with a fault
  const transformedData: FormattedOTSPResponse = data
    .filter((policy) => {
      if ('schedulePaymentDetails' in policy) {
        return true;
      } else {
        return false;
      }
    })
    .reduce(
      (map, policyResponse) => ({
        ...map,
        [policyResponse.policyNumber]: policyResponse,
      }),
      {}
    );

  return transformedData;
};

export const useOTSPQuery = (policies?: PolicySummary[] | CustomerPolicy[]) =>
  useQuery({
    queryKey: ['OTSP', policies],
    queryFn: () => getOTSPDetails(policies),
    enabled: !!(policies && policies?.length > 0),
    staleTime: 1000 * 60 * 10,
    retry: false,
  });
